import React, { useEffect, useState } from 'react';
import './PratosPrincipais.css';
import CardPratos from './../CardPratos/CardPratos';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { fireBaseApp } from './../../App';

const PratosPrincipais = () => {
  const [pratos, setPratos] = useState([]);

  const db = getFirestore(fireBaseApp);
  const cardapioRef = collection(db, 'PratosPrincipais');

  const getPratos = async () => {
    const data = await getDocs(cardapioRef);
    const pratosPrincipais = data.docs.map(doc => doc.data());
    setPratos(pratosPrincipais);
  };

  useEffect(() => {
    getPratos();
  }, []);

  return (
    <section id="pratosPrincipais">
      <h2>PRATOS PRINCIPAIS</h2>
      <ul>
        {pratos.map((prato, index) => (
          <CardPratos prato={prato} key={`@pratosPrincipais-${index}`} />
        ))}
      </ul>
    </section>
  );
};

export default PratosPrincipais;
